var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-post-table',{attrs:{"title":_vm.$t('global.models.post.heading'),"subtitle":_vm.$t('global.models.post.subheading'),"filter-config-name":_vm.filterConfigName,"management-type":'post',"form-config-name":'news'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }